// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"4a4aeca3","5953":"03e9741e","6098":"03e9741e","6552":"a3924753","7894":"ff6d452c","8558":"a3924753","8752":"03e9741e"}[chunkId] + ".chunk.css";
};